import PageHead from "../Head";
import HeaderContainer from "@/my_components/Header/HeaderContainer";
import Separator from "@/components/Common/Separator";
import SmartTechAcademy from "@/my_components/_About/SmartTechAcademy";
import MobileMenu from "@/my_components/Header/MobileMenu";
import BackToTop from "@/my_components/BackToTop/BackToTop_1";
import { ParallaxProvider } from "react-scroll-parallax";

import Context from "@/context/Context";
import Footer from "@/my_components/Footer/Footer";

const index = () => {

  return (

    <>

        <PageHead title="About Us | SmartTech Academy" />

            <Context>
                <MobileMenu />
                <HeaderContainer headerSticky="rbt-sticky" headerType="" />
                <ParallaxProvider>
                  <SmartTechAcademy />
                </ParallaxProvider>
                <BackToTop />

                <Separator />
                <Footer />
            </Context>
    </>

  );

};

export default index;
